import { Button, Drawer, Table, Typography } from "antd";
import axios from "axios";
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { UserInfo } from "../../../context";
import { useReactToPrint } from "react-to-print";
import { PrinterOutlined } from "@ant-design/icons";

const MerchantProductConsumption = ({ open, close, selectedData }) => {
  const { userData } = useContext(UserInfo);
  const scroll = {};
  const [rawConsumptionDetailsList, setRawConsumptionDetailsList] = useState({
    data: [],
    ready: false,
  });
  const tableLayout = "";
  const componentRef = useRef();
  const [paddingPrint, setPaddingPrint] = useState(0);
  const [displayDetailsPrint, setDisplayDetailsPrint] = useState(false);

  const tableProps = {
    bordered: false,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const columns = [
    {
      title: "Product",
      dataIndex: ["productsaverawproduct", "product"],
    },
    {
      title: "Description",
      dataIndex: ["productsaverawproduct", "description"],
    },
    {
      title: "Unit",
      dataIndex: ["productsaverawproduct", "rawproductsuserunit", "unit"],
    },
    {
      title: "Consumption",
      dataIndex: "consumption",
      align: "right",
    },
  ];

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const getRawConsumptionDetails = useCallback(() => {
    var params = {
      user_id: userData.data.id,
      product_id: selectedData !== null ? selectedData.id : "",
    };
    axios
      .get("user/merchant/product/consumption-raw-info", {
        params,
      })
      .then((response) => {
        const data = response.data;
        setRawConsumptionDetailsList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id, selectedData]);

  useEffect(() => {
    getRawConsumptionDetails();
  }, [getRawConsumptionDetails]);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,

    onBeforeGetContent: () => {
      return new Promise((resolve) => {
        setPaddingPrint(10);
        setDisplayDetailsPrint(true);
        resolve();
      });
    },
    onAfterPrint: () => {
      setPaddingPrint(0);
      setDisplayDetailsPrint(false);
    },
  });

  return (
    <Drawer
      title="Consumption Details"
      width={window.innerWidth > 500 ? 600 : "100vw"}
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
    >
      {selectedData !== null && (
        <div
          style={{ overflowX: "auto", padding: paddingPrint }}
          ref={componentRef}
        >
          {displayDetailsPrint && (
            <Typography.Title level={4} style={{ marginBottom: 15 }}>
              {selectedData.product} - Raw Consumption
            </Typography.Title>
          )}
          <Table
            {...tableProps}
            pagination={false}
            columns={tableColumns}
            dataSource={
              rawConsumptionDetailsList.data.length > 0
                ? rawConsumptionDetailsList.data
                : []
            }
            scroll={scroll}
            rowKey={(record) => record.productsaverawproduct.product}
          />
        </div>
      )}
      <div style={{ display: "flex", marginTop: 10 }}>
        <div style={{ flexGrow: 1 }} />
        <div>
          <Button
            type="primary"
            onClick={handlePrint}
            icon={<PrinterOutlined />}
          >
            Print
          </Button>
        </div>
      </div>
    </Drawer>
  );
};

export default MerchantProductConsumption;
